import * as originals from "./firebasegen_original";

interface AddToAuditTableParams {
  uid: string;
  event: string;
  sub_event: string;
  type: string;
  general_name?: string | null;
  game_name: string;
  success: boolean;
  ip_address: string;
  timestamp: string;
  timestamp_dt: string;
  email: string;
  comment: string;
  referrer_uid?: string | null;
}

interface AddToReferralPaymentsParams {
  referral_from_uid: any;
  referral_to_uid: any;
  source_trx: string;
  referral_date: string;
  referral_type: string | null;
  referral_item_id: any;
  amount_paid: any;
  percentage_discount: any;
  referral_payment_status: string;
  referral_payment_trx: string;
  referral_payment_wallet: string;
  referral_payment_amount: number;
  referral_payment_multipart: string;
  ineligibility_reason: string;
  ineligibility_comment: string;
}

interface TransactionsParams {
  purchase_trx: string;
  trx_source_wallet: string;
  trx_dest_wallet: string;
  trx_amount: number;
  trx_chain: string;
  trx_coin: string;
  trx_status: string;
  trx_date_time: any;
  trx_type: string;
  trx_uid: string;
  trx_comment: string;
  uid: string;
}

export const addToAuditTable = async (
  details: AddToAuditTableParams
): Promise<void> => {
  return originals.addToAuditTable(details);
};

export const getNodesForUser = async (userId: any): Promise<any | null> => {
  return originals.getNodesForUser(userId);
};

export const addToTransactions = async (
  details: TransactionsParams
): Promise<void> => {
  return originals.addToTransactions(details);
};